// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedUser: {
    user: Object,
    role: Object,
    gid: string,
  },
};

const DeleteUser = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedUser,
  } = props;

  const validate = (event) => {
    event.preventDefault();
    submit(selectedUser.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={validate} type="danger">Delete</SpButton>,
      ]}
      title="Delete Team Member"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this team member?</div>
        <SpH5>
          <div>{selectedUser.user.givenName} {selectedUser.user.familyName}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

export default DeleteUser;
